<script setup>
const props = defineProps({
  company: {
    type: Object,
    required: true,
    default: () => {
      return {}
    },
  },
})

const user = useStrapiUser()
const tagSort = useTagSort()

const showMoreTags = ref(false)

const isProfessional = computed(() => user.value?.type === 'professional')

const address = computed(() => {
  if (props.company.address) {
    return props.company.address
  }
  return null
})
</script>

<template>
  <section
    class="relative mb-4 cursor-pointer rounded-lg bg-white p-4 shadow"
    @click="
      navigateTo({ name: 'companies-slug', params: { slug: company.slug } })
    "
  >
    <CompaniesActiveFlag :is-active="company.status === 'active'" />

    <div class="items-center md:flex">
      <div class="mb-4 md:mb-0 lg:block">
        <figure
          class="relative mx-auto aspect-square w-1/3 overflow-hidden rounded-lg border border-gray-50 md:mr-6 md:w-[104px]"
          :class="{ 'flex items-center bg-[#F8FAFC]': !company.logo }"
        >
          <img
            v-if="company.logo"
            :src="$upload(company.logo, 'thumbnail')"
            alt=""
            class="absolute top-0 left-0 h-full w-full object-cover"
          />

          <img v-else class="mx-auto" src="/images/fallback.svg" />
        </figure>
      </div>
      <div class="flex-grow justify-start md:flex md:flex-col">
        <div class="mb-4 flex w-full flex-wrap items-center justify-between">
          <div class="">
            <div class="text-lg font-medium text-gray-900">
              {{ company.name }}
            </div>
            <div class="text-base text-gray-800">
              <span v-if="address">
                {{ address.city }}
              </span>
            </div>
          </div>
          <div
            v-if="company.match && company.match.average !== null"
            class="mt-6 w-1/2 md:mt-0 md:w-auto"
          >
            <div class="text-lg font-medium text-gray-900">Match</div>
            <div class="text-base text-gray-800">
              {{ company.match.average }}%
            </div>
          </div>
          <div
            v-if="isProfessional && company.matchingscore_total !== null"
            class="mr-0 mt-6 md:mr-8 md:mt-0 lg:mr-0"
          >
            <div class="text-lg font-medium text-gray-900">Match</div>
            <div class="text-base text-gray-800">
              {{ `${company.matchingscore_total}%` }}
            </div>
          </div>
        </div>

        <div
          v-if="company.tags?.length"
          class="flex w-full items-center justify-center md:justify-start"
        >
          <div class="mb-4 w-full md:mb-0">
            <Tag
              v-for="(tag, tagIndex) in showMoreTags
                ? tagSort.sort(company.tags)
                : tagSort.sort(company.tags).slice(0, 5)"
              :key="tagIndex"
              :text="tag.name"
            />
          </div>
        </div>
        <Button
          v-if="company.tags?.length > 5"
          theme="tertiary"
          class="mb-4 h-10 md:mt-4 lg:mb-0"
          @click.stop="showMoreTags = !showMoreTags"
        >
          <!-- <IconChevronDown class="h-4 w-4" /> -->
          <template #content>
            <p v-if="showMoreTags">Toon minder tags</p>
            <p v-else>Toon meer tags</p>
          </template>
          <template #icon-right>
            <IconChevronDown
              class="ml-4 h-3 w-3 transition-transform"
              :class="{ 'rotate-180': showMoreTags }"
            />
          </template>
        </Button>
      </div>
      <div
        class="flex w-full shrink-0 flex-wrap justify-end gap-2 md:ml-10 md:w-[200px] md:flex-col"
      >
        <Button
          theme="transparent"
          text="Bekijken"
          size="sm"
          class="grow basis-1/3"
        />

        <ButtonInterest
          v-if="isProfessional && company?.id"
          :target-id="company.id"
          target-type="company"
          class="grow basis-1/3"
          @click.stop
        />
      </div>
    </div>
  </section>
</template>
